import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getOne } from "../../api/breakAPI"; 
import CurrentConditions from "./CurrentConditions";
import Buoys from "./Buoys";
import PinnedConditions from "./PinnedConditions";
import Notes from "./Notes";
import BreakEntries from "../entries/BreakEntries";
import { changePageView } from "../../redux/breakSlice";
import EditBreak from "./EditBreak";

function BreakDetail() {
    const {id} = useParams();
    const dispatch = useDispatch();
    const token = useSelector(state => state.user.token)
    const breakDetail = useSelector(state => state.breaks.breakDetail);
    const pageView = useSelector(state => state.breaks.pageView)

    // GET DATA ===================================================================================
    React.useEffect(() => {
        dispatch(getOne({id, token}))
        dispatch(changePageView("current"))
    }, [dispatch, id, token])

    // DOM RENDER ====================================================================================
    return(
        <div className="content">
            <h1 className="mb-12 mobile-hidden">{breakDetail.name}</h1>
            <h1 className="mb-10 desktop-hidden">{breakDetail.name}</h1>

            {breakDetail.timezone === undefined && <p className="error mb-16">UPDATE: Breaks now adjust for time zone. Please update the time zone for this break in the edit tab</p>}

            <div className="journal bg-white w-10/12 m-auto rounded-lg shadow-lg p-2 sm:p-6 mobile-w-full">
                <div className="tabs overflow-x-atuo">
                    <p className={`${pageView === "current" ? "tab-selected" : "tab"}`} onClick={() => dispatch(changePageView("current"))}>Current Conditions</p>
                    <p className={`${pageView === "pinned" ? "tab-selected" : "tab"}`} onClick={() => dispatch(changePageView("pinned"))}>Pinned Entries</p>
                    <p className={`${pageView === "entries" ? "tab-selected" : "tab"}`} onClick={() => dispatch(changePageView("entries"))}>Journal Entries</p>
                    <p className={`${pageView === "notes" ? "tab-selected" : "tab"}`} onClick={() => dispatch(changePageView("notes"))}>Notes</p>
                    <p className={`${pageView === "buoys" ? "tab-selected" : "tab"}`} onClick={() => dispatch(changePageView("buoys"))}>Buoys</p>
                    <p className={`${pageView === "edit" ? "tab-selected" : "tab"}`} onClick={() => dispatch(changePageView("edit"))}>Edit Break</p>
                </div>

                {pageView === "current" && <CurrentConditions />}
                {pageView === "pinned" && <PinnedConditions />}
                {pageView === "notes" && <Notes />}
                {pageView === "entries" && <BreakEntries />}
                {pageView === "buoys" && <Buoys />}
                {pageView === "edit" && <EditBreak />}
            </div>

        </div>
    )
}

export default BreakDetail;